import React from 'react';
import { Card, Stack, Typography } from '@mui/material';
import { AppColors } from '../../../Utils/helper/AppColors';
import { LightningChargeIcon } from '../../../Components/Icons/Icons';


const formatValue = (val) => {
    if (!val && val !== 0) return '0';
    const num = parseFloat(val);
    if (isNaN(num)) return '0';
    if( num > 100000) return "100000 +";
    return num % 1 === 0 ? num.toString() : num.toFixed(1);
};
export default function MetricCard({ 
    title, 
    value, 
    extra, // Optional extra value for additional information
    subtitle, 
    background, 
    height = 146,
    titleColor = AppColors.HEADING_TITLE4,
    valueColor = AppColors.HEADING_TITLE,
    subtitleColor = AppColors.HEADING_TITLE4,
    borderColor = 'none',
    titleSize = 20,
    valueSize = 36,
    subtitleSize = 14,
    ...props 
}) {
    return (
        <Card
            sx={{
                height,
                background,
                border: `1px solid ${borderColor}`,
                borderRadius: 2,
                p: 3,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                ...props.sx
            }}
            {...props}
        >
            <Stack direction="row" alignItems="center" sx={{ mb: 1 , gap : 1 }}>
            
            <LightningChargeIcon size={20} color={titleColor} />
            <Typography
                sx={{
                    fontSize: titleSize,
                    fontWeight: 600,
                    color: titleColor,
                    fontFamily: 'Poppins',
                }}
            >
                {title}
            </Typography>
            </Stack>
            <Typography
                sx={{
                    fontSize: valueSize,
                    fontWeight: 700,
                    color: valueColor,
                    fontFamily: 'Poppins',
                    mb: 0.5,
                }}
            >
              {console.log(typeof(value))}
             {extra ? `${value} / ${extra} ` : formatValue(value)}  
            </Typography>
            <Typography
                sx={{
                    fontSize: subtitleSize,
                    fontWeight: 400,
                    color: subtitleColor,
                    fontFamily: 'Poppins',
                }}
            >
                {subtitle}
            </Typography>
        </Card>
    );
}